import { useEffect } from 'react'
import { getSocket } from './socketManager'

interface PreAuthorizationMethodSelectedData {
  storeId?: string | number
  kioskId?: string | number
  storeLabel?: string
  timestamp?: string
  [key: string]: unknown
}

export const usePreAuthorizationMethodSelectedNotifications = (
  onPreAuthorizationMethodSelected?: (data: PreAuthorizationMethodSelectedData) => void,
) => {
  useEffect(() => {
    const socket = getSocket()

    const handler = (data: PreAuthorizationMethodSelectedData) => {
      if (onPreAuthorizationMethodSelected) onPreAuthorizationMethodSelected(data)
    }

    socket.on('pre-authorization-method-selected', handler)

    return () => {
      socket.off('pre-authorization-method-selected', handler)
    }
  }, [onPreAuthorizationMethodSelected])
}
